// Le user est créé par l'API SSO mais n'a pas de rôle "métier"
export var ROLE_SSO_REGISTERED = "sso-registered";
// Les rôles métier
export var ROLE_LYCEEN = "lyceen";
export var ROLE_ECLAIREUR = "eclaireur";
export var ROLE_PROF = "pedagogie";
// Le rôle admin
export var ROLE_ADMIN = "admin";
